import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/web/',  //本地测试请开启
  routes: [
    {
      path: '/index',
      component: resolve => require(['@/website/pages/index'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/website/pages/login'], resolve)
    },
    {
      path: '/detail',
      name: 'detail',
      component: resolve => require(['@/website/pages/detail'], resolve)
    },
    {
      path: '/download',
      name: 'download',
      component: resolve => require(['@/website/pages/download'], resolve)
    },
    {
      path: '*',
      component: resolve => require(['@/website/pages/index'], resolve)
    }
  ]
})
